import create from './base'
import {
	stringify
} from 'qs'
import {
	baseUrl
} from '../config'

const http = create()
http.defaults.baseURL = baseUrl + '/api/inforeview'

// 我的评审
const queryMyreview = (data) => {
	return http.get('/v1/query_myreview?' + stringify(data))
}

//评审得分
const score = (data) => {
	return http.post('/v1/score', data, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
}
// 我的评审详情
const getMreview = (data) => {
	return http.get('/v1/get_myreview?' + stringify(data))
}


//我的仲裁评审
const queryArbitration = (data) => {
	return http.get('/v1/query_arbitration?'+ stringify(data))
}


//仲裁得分
const arbitrationScore = ( data ) => {
	return http.post('/v1/arbitration_score', data, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
}


//仲裁评审获取普通评审记录
const queryReviewRecord = (data) => {
	return http.get('/v1/query_review_record?'+stringify(data))
}

//参赛评审结果查询
const queryReviewResult = (data) => {
	return http.get('/v1/query_review_result?' + stringify(data))
}
//参赛评审结果查询详情
const getReviewResult = (data) => {
	return http.get('/v1/get_review_result?' + stringify(data))
}

//修改参赛评审结果
const updateReviewResult = (data) => {
	return http.post('/v1/update_review_result', data, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
}

// 参赛评审结果导出
const exportReviewResult = (data) => {
	return http.get('/v1/export_review_result?' + stringify(data))
}

// 查询下一个评审作品
const queryMyreviewNext = (data) => {
	return http.get('/v1/query_myreview_next?' + stringify(data))
}

// 查询评审人的评审信息
const queryEnroll = (data) => {
	return http.get('/v1/query_enroll?' + stringify(data))
}


//更改作品评审人员
const changeReviewer = ( data ) => {
    return http.post('/v1/change_reviewer', stringify(data))
}

// 以下为二次需求修改所用参数
//参赛评审结果查询详情[二级维度]
const getReviewResultTwoV2 = ( data ) => {
    return http.get('/v2/get_review_result?' + stringify(data))
}
// 参赛评审结果查询详情[三级维度]
const getReviewResultTwoV3 = ( data ) => {
    return http.get('/v3/get_review_result?' + stringify(data))
}

// 我的评审详情[二级维度]
const getMeviewTwoV2 = ( data ) => {
    return http.get('/v2/get_myreview?' + stringify(data))
}
// 我的评审详情[三级维度]
const getMeviewTwoV3 = ( data ) => {
    return http.get('/v3/get_myreview?' + stringify(data))
}

// 仲裁评审获取普通评审详情[二级维度]
const queryReviewRecordTwoV2 = ( data ) => {
    return http.get('/v2/query_review_record?' + stringify(data))
}
// 仲裁评审获取普通评审详情[三级维度]
const queryReviewRecordTwoV3 = ( data ) => {
    return http.get('/v3/query_review_record?' + stringify(data))
}

//我所参与的内容
const queryReviewerTask = (data) => {
	return http.get('/v1/query_reviewer_task?' + stringify(data))
}

export default {
	queryMyreview,
	score,
	getMreview,
	queryArbitration,
	arbitrationScore,
	queryReviewRecord,
	queryReviewResult,
	getReviewResult,
	updateReviewResult,
	exportReviewResult,
	queryMyreviewNext,
	queryEnroll,
	changeReviewer,
	getReviewResultTwoV2,
	getReviewResultTwoV3,
	getMeviewTwoV2,
	getMeviewTwoV3,
	queryReviewRecordTwoV2,
	queryReviewRecordTwoV3,
	queryReviewerTask

}
